import { render } from "./BenefitOurProduct.vue?vue&type=template&id=204fe096"
import script from "./BenefitOurProduct.vue?vue&type=script&lang=js"
export * from "./BenefitOurProduct.vue?vue&type=script&lang=js"

import "./BenefitOurProduct.vue?vue&type=style&index=0&id=204fe096&lang=css"

import exportComponent from "D:\\VueJs project\\product\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__